module.exports = __webpack_public_path__ + "img/SI5446546.e04ea63f.gif";